/** 后端和前端的文案key不一致，这里做个转换 */ var ERROR_MESSAGE_MAP = {
    WRONG_ACCOUNT_OR_PASSWORD: 'Wrong_Accout_Or_Password',
    USER_NOT_EXISTS: 'Login_User_NotExists',
    USER_NOT_LOGIN: 'Common_User_NotLogin',
    MIN_REQ_EXCEEDS_LIMIT: 'Request_PerMinute_Limit'
};
/** 通过接口返回的KEY查找本地的i18n文案 */ export function getErrorMessage(key) {
    if (!key) {
        return intl.get('Http_Error_Data');
    }
    var text = intl.get(key);
    if (text && text !== key) {
        // key存在文案就不走转换
        return text;
    }
    if (ERROR_MESSAGE_MAP[key]) {
        return intl.get(ERROR_MESSAGE_MAP[key]);
    }
    return intl.get('Http_Error_Data');
}
